"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLinkBrandColors = void 0;
var getLinkBrandColors = function (colors, brand) {
    if (brand === 'valtra') {
        return {
            primary: {
                active: colors.secondary.brand,
                visited: colors.secondary.shades[600],
                disabled: colors.primary.grays[200],
            },
            secondary: {
                active: colors.primary.grays[800],
                visited: colors.primary.grays[800],
                disabled: colors.primary.grays[400],
            },
            negative: {
                active: colors.primary.grays[400],
                visited: colors.primary.grays[400],
                disabled: colors.primary.grays[200],
            },
        };
    }
    return {
        primary: {
            active: colors.secondary.brand,
            visited: colors.secondary.shades[400],
            disabled: colors.primary.grays[400],
        },
        secondary: {
            active: colors.primary.grays[600],
            visited: colors.primary.grays[600],
            disabled: colors.primary.grays[400],
        },
        negative: {
            active: colors.primary.grays[200],
            visited: colors.primary.grays[200],
            disabled: colors.primary.grays[400],
        },
    };
};
exports.getLinkBrandColors = getLinkBrandColors;
